import {
  FILTERS_TRANSLATE_DASHBOARD_ACTIONS,
  IFiltersTranslateDashboard
} from '../actions/filters-translate-dashboard.actions';

export const INITIAL_FILTERS_TRANSLATE_DASHBOARD_STATE: IFiltersTranslateDashboard = {
  translationTypes: []
};

export function filtersTranslateDashboardReducer(state: IFiltersTranslateDashboard = INITIAL_FILTERS_TRANSLATE_DASHBOARD_STATE, action) {
  switch (action.type) {

    case FILTERS_TRANSLATE_DASHBOARD_ACTIONS.SET_TRANSLATION_TYPES:
      return { ...action.payload };

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/app/store/reducers/filters-translate-dashboard.reducer.ts